import React from 'react';
import { IIconProps } from './utils';

export const Anchor = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      clipRule="evenodd"
      d="M14.8329 2.99048C13.7148 2.99048 12.8083 3.8969 12.8083 5.01504C12.8083 6.13317 13.7148 7.0396 14.8329 7.0396C15.951 7.0396 16.8575 6.13317 16.8575 5.01504C16.8575 3.8969 15.951 2.99048 14.8329 2.99048ZM10.3083 5.01504C10.3083 2.51619 12.3341 0.490479 14.8329 0.490479C17.3318 0.490479 19.3575 2.51619 19.3575 5.01504C19.3575 7.08027 17.9738 8.82232 16.0829 9.36472V13.5C16.0829 14.1904 15.5233 14.75 14.8329 14.75C14.1426 14.75 13.5829 14.1904 13.5829 13.5L13.5829 9.36472C11.692 8.82232 10.3083 7.08027 10.3083 5.01504Z"
      fill={fill}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.1953 13.3708C10.1953 12.6804 10.755 12.1208 11.4453 12.1208L18.2203 12.1208C18.9106 12.1208 19.4703 12.6804 19.4703 13.3708C19.4703 14.0611 18.9106 14.6208 18.2203 14.6208L11.4453 14.6208C10.755 14.6208 10.1953 14.0611 10.1953 13.3708Z"
      fill={fill}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M14.8329 13.4758C15.5232 13.4758 16.0829 14.0354 16.0829 14.7258V26.4835C19.5864 25.9718 22.4021 23.3412 23.1875 19.9342L21.0276 20.7982C20.3866 21.0546 19.6591 20.7428 19.4027 20.1018C19.1463 19.4609 19.4581 18.7334 20.0991 18.477L24.1923 16.8397C24.6566 16.654 25.1868 16.7629 25.5404 17.1164L28.815 20.391C29.3031 20.8792 29.3031 21.6706 28.815 22.1588C28.3268 22.6469 27.5354 22.6469 27.0472 22.1588L25.5778 20.6893C24.3763 25.5057 20.0213 29.074 14.8329 29.074C9.64441 29.074 5.28939 25.5057 4.08793 20.6893L2.6185 22.1588C2.13035 22.6469 1.33889 22.6469 0.850736 22.1588C0.36258 21.6706 0.36258 20.8792 0.850736 20.391L4.12529 17.1164C4.47887 16.7629 5.00915 16.654 5.47342 16.8397L9.56661 18.477C10.2076 18.7334 10.5194 19.4609 10.263 20.1018C10.0066 20.7428 9.27912 21.0546 8.63814 20.7982L6.47818 19.9342C7.26361 23.3412 10.0794 25.9718 13.5829 26.4835V14.7258C13.5829 14.0354 14.1425 13.4758 14.8329 13.4758Z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);
